import React from 'react'

const Goals = () => {
  return (
    <div className="exquite-goals">
      <h4>Goals</h4>
      <ul>
        <li>
          <p>To build an application that supports specific user tasks.</p>
        </li>
        <li>
          <p>Extend the capabilities of the company to mobile users.</p>
        </li>
        <li>
          <p>Facillitate car rent services through the mobile application.</p>
        </li>
      </ul>
    </div>
  )
}

export default Goals